import ApiClient from './ApiClient';
import { ApiConfiguration } from './ApiClient';
import ChangeLogService from './ChangeLogService';
import CompanyService from './CompanyService';
import UserAccessService from './UserAccessService';
import IndustryService from './IndustryService';
import LocationService from './LocationService';
import AutoCompleteService from './AutoCompleteService';
import LogService from './LogService';

const apiConfig = new ApiConfiguration();
apiConfig.apiBaseUrl = process.env.REACT_APP_API_ENDPOINT;

export const companyService = new CompanyService(new ApiClient(apiConfig));
export const autoCompleteService = new AutoCompleteService(new ApiClient(apiConfig));
export const userAccessService = new UserAccessService(new ApiClient(apiConfig));
export const changeLogService = new ChangeLogService(new ApiClient(apiConfig));
export const industryService = new IndustryService(new ApiClient(apiConfig));
export const locationService = new LocationService(new ApiClient(apiConfig));
export const logService = new LogService(new ApiClient(apiConfig));